import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createVNode(_component_FormInput, {
      modelValue: _ctx.username,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
      name: "Username",
      type: "text",
      error: _ctx.usernameSatus.message
    }, null, 8, ["modelValue", "error"]),
    _createVNode(_component_FormInput, {
      modelValue: _ctx.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
      name: "Password",
      type: "password",
      error: _ctx.passwordStatus.message
    }, null, 8, ["modelValue", "error"]),
    _createElementVNode("button", {
      class: _normalizeClass(["flex justify-center px-3 py-3 mx-auto text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-green-500 rounded shadow outline-none active:bg-green-600 hover:shadow-lg focus:outline-none", { disabled: !_ctx.usernameSatus.valid || !_ctx.passwordStatus.valid }])
    }, " Sign UP ", 2)
  ], 32))
}